export default __webpack_public_path__ + "static/media/direction-arrow-icon.b04911af.svg";